import React from 'react'
import TeacherNav from './TeacherNav'
import GetTeacherForm from './GetTeacherForm'

export default function Teacher() {
  return (
    <div><TeacherNav/>
    <GetTeacherForm/>
    </div>
  )
}
